import React from 'react';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { useTranslation } from 'react-i18next';

import { getDeploymentDateTime, xlsxDownload } from '../../../Functions/utils';


const excelDownload = (t, type) => {
  const date = getDeploymentDateTime();
  const fileDate = date.year + date.month + date.day + '-' + date.time.split(':').join('');

  xlsxDownload({
    header: document.getElementById('print__header'),
    content: document.getElementById('print__content'),
    filename: t('realtime.export.filename', {type: t('realtime.export.' + type), date: fileDate })
  });
};

const pdfDownload = async (t, type) => {
  const date = getDeploymentDateTime();
  const fileDate = date.year + date.month + date.day + '-' + date.time.split(':').join('');
  const fileName = t('realtime.export.filename', {type: t('realtime.export.' + type), date: fileDate });

  const table = document.getElementById('print');

  let doc = new jsPDF('p', 'pt', 'A4');
  doc.html(table, {
    margin: 20,
    elementHandlers: () => true,
    html2canvas: html2canvas(table),
    callback: (doc) => doc.save(fileName + '.pdf')
  });
};


export default function ExportDeployments({type}) {
  const { t } = useTranslation();

  return (
    <>
      <button
        className="button icon"
        title={t('global.actions.xlsx')}
        onClick={() => excelDownload(t, type)}
      >
        <span className="material-icons-round">table_view</span>
      </button>

      <button style={{display: 'none'}}
        className="button icon"
        title={t('global.actions.pdf')}
        onClick={() => pdfDownload(t, type)}
      >
        <span className="material-icons-round" style={{fontSize: '28px'}}>picture_as_pdf</span>
      </button>
    </>
  );
}
